import { API } from "@/services/api";
import { IAPIResponse } from "@/services/api.types";
import { invitationEndpoints } from "@/constant/endpoints";
import {
  AcceptInviteFormData,
  AcceptInviteResponse,
  DealInviteFormData,
  Invitation,
  InvitationTokenResponse,
  OrgInviteFormData,
  ResendInvitationPayload,
  ResendInvitationResponse,
  RevokeInvitationPayload,
  RevokeInvitationResponse,
} from "@/types/invitations.types";

export const postOrgInviteService = async (payload: OrgInviteFormData): Promise<IAPIResponse<Invitation>> => {
  return API.Post<OrgInviteFormData, Invitation>(invitationEndpoints.inviteOrg, payload);
};

export const postDealInviteService = async (payload: DealInviteFormData): Promise<IAPIResponse<Invitation>> => {
  return API.Post<DealInviteFormData, Invitation>(invitationEndpoints.inviteDeal, payload);
};

export const getInvitationsService = async (): Promise<Invitation[]> => {
  const response = await API.Get<Invitation[]>(invitationEndpoints.list);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postRevokeInvitationService = async (
  invitationId: string,
  payload: RevokeInvitationPayload
): Promise<IAPIResponse<RevokeInvitationResponse>> => {
  return API.Post<RevokeInvitationPayload, RevokeInvitationResponse>(invitationEndpoints.revoke(invitationId), payload);
};

export const postResendInvitationService = async (
  invitationId: string,
  payload: ResendInvitationPayload
): Promise<IAPIResponse<ResendInvitationResponse>> => {
  return API.Post<ResendInvitationPayload, ResendInvitationResponse>(invitationEndpoints.resend(invitationId), payload);
};

export const getInvitationByTokenService = async (token: string): Promise<InvitationTokenResponse> => {
  const response = await API.Get<InvitationTokenResponse>(invitationEndpoints.byToken(token));
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postAcceptInviteService = async (
  token: string,
  payload: AcceptInviteFormData
): Promise<IAPIResponse<AcceptInviteResponse>> => {
  return API.Post<AcceptInviteFormData, AcceptInviteResponse>(invitationEndpoints.accept(token), payload);
};
